import AppDispatcher from '../../../core/AppDispatcher'
import { appActions } from '../../AppActions'
import MonthlyReportEvent from '../../../event/MonthlyReportEvent'
import monthlyReportRepository from '../../../infra/MonthlyReportRepository'

const fetchByDate = async (date, hotel_id) => {
  const response = await monthlyReportRepository.fetchMonthlySales(date, hotel_id).catch(e => e)
  if (response instanceof Error) {
    AppDispatcher.dispatchWithType(MonthlyReportEvent.monthlySalesMonthChanged, [])
    appActions.showAlert(response, '取得できませんでした')
    return false
  }

  AppDispatcher.dispatchWithType(MonthlyReportEvent.monthlySalesMonthChanged, response)

  return true
}

export default fetchByDate
